import { ref } from "@vue/composition-api";
import { toNumber } from "lodash-es";
import { colorList, FillBackgroundType, FontsType } from "../../../../config";
import { ColorScheme } from "../../../../types";

export default function useColor() {
  const textColor = ref<string>(colorList[0]);
  const backgroundColors = ref<string[]>([colorList[0]]);

  const colorChannelMixer = (colorChannelA: number, colorChannelB: string, amountToMix: number) => {
    const channelA = colorChannelA * amountToMix;
    const channelB = toNumber(colorChannelB) * (1 - amountToMix);
    return channelA + channelB;
  };

  const colorMixer = (rgbA: number[], rgbB: RegExpMatchArray, amountToMix: number) => {
    const r = colorChannelMixer(rgbA[0], rgbB[0], amountToMix);
    const g = colorChannelMixer(rgbA[1], rgbB[1], amountToMix);
    const b = colorChannelMixer(rgbA[2], rgbB[2], amountToMix);
    return `rgb(${r}, ${g}, ${b})`;
  };

  const getNewRGB = (rgb: RegExpMatchArray, saturate: number): string => {
    const r = 255 + (toNumber(rgb[0]) - 255) * saturate;
    const g = 255 + (toNumber(rgb[1]) - 255) * saturate;
    const b = 255 + (toNumber(rgb[2]) - 255) * saturate;
    return `rgb(${r}, ${g}, ${b})`;
  };

  /** Меняет значения цветов текста и фона */
  const onChangeColorsState = (colorScheme: ColorScheme, currentFont: FontsType) => {
    const rgb = colorScheme.color.match(/\d+/g);
    const isWhite = toNumber(colorScheme.colorIndex) === 0;
    const isBlack = toNumber(colorScheme.colorIndex) === 1;
    const isLightenColors = toNumber(colorScheme.colorIndex) > 7 && !!rgb;

    textColor.value = colorScheme.color;
    if (colorScheme.fillType === FillBackgroundType.EMPTY) {
      backgroundColors.value = [colorScheme.color];
    } else if (colorScheme.fillType === FillBackgroundType.ACTIVE) {
      if (isWhite) {
        backgroundColors.value = ["rgb(0,0,0)"];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push("rgb(128,128,128)");
        }
      } else if (isBlack) {
        backgroundColors.value = ["rgb(255,255,255)"];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push("rgb(128,128,128)");
        }
      } else if (isLightenColors) {
        if (!rgb) return;
        backgroundColors.value = [colorMixer([0, 0, 0], rgb, 0.9)];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push(colorMixer([0, 0, 0], rgb, 0.5));
        }
      } else {
        if (!rgb) return;
        backgroundColors.value = [getNewRGB(rgb, currentFont === FontsType.INTER ? 0.3 : 0.05)];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push(getNewRGB(rgb, 0.6));
        }
      }
    } else if (colorScheme.fillType === FillBackgroundType.ACTIVE_INVERT) {
      if (isWhite) {
        textColor.value = "rgb(0,0,0)";
        backgroundColors.value = ["rgb(255,255,255)"];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push("rgb(128,128,128)");
        }
      } else if (isBlack) {
        textColor.value = "rgb(255,255,255)";
        backgroundColors.value = ["rgb(0,0,0)"];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push("rgb(128,128,128)");
        }
      } else if (isLightenColors) {
        if (!rgb) return;
        textColor.value = colorMixer([0, 0, 0], rgb, 0.9);
        backgroundColors.value = [colorScheme.color];
        if (currentFont === FontsType.INTER) {
          backgroundColors.value.push(colorMixer([0, 0, 0], rgb, 0.5));
        }
      } else {
        if (!rgb) return;
        textColor.value = getNewRGB(rgb, 0.05);
        if (currentFont === FontsType.INTER) {
          backgroundColors.value = [getNewRGB(rgb, 0.6), getNewRGB(rgb, 0.3)];
        } else {
          backgroundColors.value = [colorScheme.color];
        }
      }
    }
  };

  return {
    textColor,
    backgroundColors,
    onChangeColorsState,
  };
}
